import styled from 'styled-components';

export const SectionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const Section = styled.div`
    width: 50%;
`;